

























































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/agiles/common';

@Component
export default class AuditLogView extends Vue {
  public items: Common.AuditLog[] = new Array();
  public params: Common.AuditLogQuery = new Common.AuditLogQuery();
  public exportQuery = new Common.AuditLogExportQuery('更新履歴', this.params);  
  //未設定
  public sortOptions: any = [
    { value: 'timeStamp', text: '更新日時' },
    { value: 'auditName', text: '伝票名称' },
  ];

  public created(){
    this.params.loadAll = false;
    String.format(this.$api.formatter.formatByList('',"auditSources"),'');//ハッシュ登録
  }

  public show(item: Common.AuditLog){
    var url = String.format(this.$api.formatter.formatByList(item.auditName,"auditSources"),item.auditNo);
    if (url){ this.$router.push(url);}
  }

    // 詳細画面に移動ボタンの活性制御
  public disabledShowButton(audit: Common.AuditLog){
    return audit.type == Common.auditTypes.deleted;
  }
}
